export default __webpack_public_path__ + "static/2_32-3c07685dd49c44504780da96c94db0a8.png";